import React from 'react';
import { Button, Callout, Flex, FlexColumn, Icon, Text, Tooltip } from 'core/components';
import SidebarItem from 'app/views/hybrid/maps/components/popovers/SidebarItem';

export default function KentikAgentDrawerSection(props) {
  const { children, isChart, title, error, onRetry, onDismiss, ...rest } = props;

  const contentHeight = isChart ? 200 : 'auto';

  return (
    <SidebarItem
      excludeFormProps
      title={
        <Text as="div" fontWeight="bold" width="100%" mr="20px">
          {title}
        </Text>
      }
      openOnMount
      showMaximizeButton={false}
      {...rest}
    >
      <FlexColumn gap={2} my={1} mx="20px" height={contentHeight}>
        {error && (
          <Callout intent="danger" p={2} py={1} role="alert">
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center" gap={1}>
                <Icon icon="warning-sign" color="danger" />
                {error}
              </Flex>
              <Flex alignItems="center" gap={0}>
                {onRetry && (
                  <Tooltip content="Retry" ariaLabel="Retry">
                    <Button icon="refresh" intent="danger" minimal ariaLabel="Retry" onClick={onRetry} />
                  </Tooltip>
                )}
                {onDismiss && (
                  <Tooltip content="Dismiss" ariaLabel="Dismiss">
                    <Button icon="cross" intent="danger" minimal ariaLabel="Dismiss" onClick={onDismiss} />
                  </Tooltip>
                )}
              </Flex>
            </Flex>
          </Callout>
        )}
        {children}
      </FlexColumn>
    </SidebarItem>
  );
}
